
<template>
   <div >
          <button
            @click="$emit('pressed')"
            class="block bg-blue-600 text-base bg-opacity-75 hover:bg-opacity-50 focus:bg-red-500 focus:bg-opacity-50 text-white font-semibold rounded py-3 px-4"
          >
            <i class="fas fa-exclamation-triangle mr-2"></i> Upgrade Account
          </button>
        </div>
</template>

<script>
export default {
  name: "notice",
  data() {
    return {
    
    };
  },
  methods: {
   
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
